import './chatbotUserMsg.css';
import {cn} from "../../../../../utils/utils";
import {useSelector} from "react-redux";
import users from "../../../../users";

const ChatbotUserMsg = ({msg, isFirst, isLast}) => {
    const darkMode = useSelector(users.selectors.isDarkMode);
    return (
        <div
            className={cn("chatbot-user-msg", {"chatbot-user-msg__dark": darkMode}, {"not-first-msg": !isFirst}, {"last-user-msg": isLast})}>
            <span>{msg.text}</span>
        </div>
    );
}

export default ChatbotUserMsg;
